export default "__VITE_ASSET__sKOuzsAz__"